module.exports = __webpack_public_path__ + "stockLibrary/preview-default-3500b4a0790b6daef6ae26496e1d27fb.svg";